export class SetCurrentGridPage {
	static readonly type = '[Intelligence][Import] SetCurrentGridPage';
	constructor(public page: number) {}
}

export class SetIsImportingOrder {
	static readonly type = '[Intelligence][Import] SetIsImportingOrder';
	constructor(public isImportingOrder: boolean) {}
}

export class SetIflagSoftDelete {
	static readonly type = '[Intelligence][Import] SetIsImportingOrder';
	constructor(public sofDelete: boolean) {}
}
